(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/assets/javascripts/rounds/views/rounds-items.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/assets/javascripts/rounds/views/rounds-items.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.app.productStartPage.rounds.views.RoundsItems = Backbone.Marionette.CollectionView.extend({
    childView: svs.app.productStartPage.rounds.views.RoundItem,
    childViewOptions: function(model, index) {
      return {
        index: index
      };
    },
    className: 'rounds-items',
    initialize: function() {
      var itemsCount = this.collection.length;
      var itemWidth = 250;
      var itemMargin = 6;
      var rows = this.options.rows ? this.options.rows : 1;
      var cols = Math.ceil(itemsCount / rows);
      var totalMargin = itemMargin * (cols - 1);
      var totalWidth = cols * itemWidth + totalMargin;

      if (itemsCount >= 9 && this.options.type === 'columns') {
        this.$el.addClass('rounds-items-rows');
      }
      this.$el.width(totalWidth);
    },
    template: function() {
      return '';
    }
  });
})(Backbone, _, svs);

 })(window);